import { type RefObject, useEffect, useState } from 'react'

export function useOnScreen(ref?: RefObject<HTMLElement>, rootMargin = '0px') {
  const [isIntersecting, setIntersecting] = useState<boolean | undefined>(false)
  const r = ref?.current
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry?.isIntersecting)
      }, { rootMargin }
    )
    r && observer.observe(r)

    return () => {
      r && observer.unobserve(r)
    }
  }, [r, rootMargin])
  return isIntersecting
}
export function hasTouch() {
  if ( typeof window === 'undefined' || typeof navigator === 'undefined') return false
  return ( 'ontouchstart' in window ) ||
         ( navigator.maxTouchPoints > 0 ) ||
         // @ts-expect-error for MS
         ( navigator.msMaxTouchPoints > 0 )
} 